import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LoadingAnimation from '../loading-animation/LoadingAnimation';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import UserService from '../../services/UserService';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import PasswordField from '../password/PasswordField';

function invalidEmail(email) {
    if (!email) return;
    if (!/\w+@\w+\.\w+/.test(email)) {
        return 'A vaild email is required';
    }
}

function invalidPassword(password) {
    if (!password) return;
    if (password.length < 6) {
        return 'Passwords must be at least 6 characters';
    }
    // const lowercase = /[a-z]/;
    // const uppercase = /[A-Z]/;
    // const numbers = /[0-9]/;
    const allowedSpecials = [
        '!',
        '@',
        '#',
        '$',
        '%',
        '^',
        '&',
        '*',
        '(',
        ')',
        '_',
        '+',
        '-',
        '=',
        ',',
        '?',
        '.'
    ];
    // const specialRE = new RegExp(`[${allowedSpecials.map((c) => `\\${c}`).join('')}]`);
    const badcharacters = new RegExp(
        `[^a-zA-Z0-9${allowedSpecials.map((c) => `\\${c}`).join('')}]`
    );
    if (
        !(
            // lowercase.test(password) &&
            // uppercase.test(password) &&
            // numbers.test(password) &&
            // specialRE.test(password)
            (password.length > 5)
        )
    ) {
        // return 'Must have one of each: lowercase letter, uppercase letter, number, special character';
        return 'Password must have at least 6 characters';
    }
    if (badcharacters.test(password)) {
        return `Only these special characters are valid: ${allowedSpecials.join('')}`;
    }
}

function readyForSubmit(userobject) {
    return (
        Object.values(userobject).every(({ value }) => value) &&
        Object.values(userobject).every(({ error }) => !error)
    );
}

export default function (props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [existing, setExisting] = useState({ email: { value: '' }, password: { value: '' } });
    const [newUser, setNewUser] = useState({
        email: { value: '', error: '' },
        password: { value: '', error: '' },
        verify: { value: '', error: '' },
        first: { value: '', error: '' },
        last: { value: '', error: '' }
    });
    const [tab, setTab] = useState(props.tab ?? 0);
    useEffect(() => setTab(props.tab ?? 0), [props.tab]);
    const [submitError, setSubmitError] = useState('');
    const [guestName, setGuestName] = useState('');

    function enterAsGuest(e) {
        e.preventDefault();
        const roomUrl = props.directURL;
        if (roomUrl) {
            if (guestName) {
                sessionStorage.setItem('guestDisplayName', guestName);
            }
            navigate(`/watch/${roomUrl}`);
        }
    }

    function closeDialog() {
        if (props.onClose) props.onClose();
    }

    function nativeLogin(e) {
        e.preventDefault();
        setLoading(true);
        setSubmitError('');
        UserService.login(existing.email.value, existing.password.value)
            .catch((error) => {
                const message = error.response?.data?.message || error.message || 'Login failed';
                setSubmitError(message);
            })
            .then(() => {
                setLoading(false);
            });
    }

    function createAccount(e) {
        e.preventDefault();
        setLoading(true);
        setSubmitError('');
        const data = {
            email: newUser.email.value,
            password: newUser.password.value,
            first: newUser.first.value,
            last: newUser.last.value
        };
        UserService.createAccount(data)
            .catch((error) => {
                const message = error.response?.data?.message || error.message || 'Account creation failed';
                setSubmitError(message);
            })
            .then(() => {
                setLoading(false);
            });
    }

    return (
        <Dialog open={props.open} onClose={closeDialog} maxWidth='sm'>
            <Grid container alignItems='stretch' alignContent='center' direction='column'>
                <AppBar position='static'>
                    <Tabs
                        value={tab}
                        onChange={(e, newValue) => setTab(newValue)}
                        textColor="inherit"
                        indicatorColor="secondary"
                        sx={{
                            '& .MuiTab-root': {
                                color: 'rgba(255, 255, 255, 0.7)',
                            },
                            '& .Mui-selected': {
                                color: 'white',
                            }
                        }}
                    >
                        <Tab label='Existing User' onClick={() => setSubmitError('')} />
                        <Tab label='New User' onClick={() => setSubmitError('')} />
                    </Tabs>
                </AppBar>
            </Grid>
            <Accordion expanded={`panel${tab + 1}` === 'panel1'}>
                <AccordionSummary style={{ display: 'none' }} />
                <AccordionDetails>
                    <form style={{ width: '100%' }} onSubmit={nativeLogin} autoComplete='on'>
                        <Grid container spacing={1} alignItems='stretch' direction='column'>
                            <Grid item>
                                <TextField
                                    required
                                    autoComplete='email'
                                    autoFocus
                                    id='email_existing'
                                    label='Email Address'
                                    variant='outlined'
                                    value={existing.email.value}
                                    onChange={({ target: { value } }) =>
                                        setExisting({ ...existing, email: { value } })
                                    }
                                    onBlur={() =>
                                        setExisting({
                                            ...existing,
                                            email: {
                                                ...existing.email,
                                                error: invalidEmail(existing.email.value)
                                            }
                                        })
                                    }
                                    helperText={existing.email.error}
                                    error={!!existing.email.error}
                                    
                                />
                            </Grid>
                            <Grid item>
                                <PasswordField
                                    autoComplete='current-password'
                                    required
                                    id='password'
                                    label='Password'
                                    variant='outlined'
                                    value={existing.password.value}
                                    onChange={({ target: { value } }) =>
                                        setExisting({ ...existing, password: { value } })
                                    }
                                    onBlur={() =>
                                        setExisting({
                                            ...existing,
                                            password: {
                                                ...existing.password
                                            }
                                        })
                                    }
                                    helperText={existing.password.error}
                                    error={!!existing.password.error}
                                    
                                />
                            </Grid>
                            <Grid item>
                                <FormControl >
                                    <Button
                                        disabled={!readyForSubmit(existing)}
                                        // onClick={nativeLogin}
                                        variant='contained'
                                        color='primary'
                                        type='submit'
                                        >
                                        Login
                                    </Button>
                                    <FormHelperText error id='component-error-text'>
                                        {submitError}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item><Link to='/forgot-password' style={{ color: 'unset', textDecoration: 'unset' }}>Forgot your password?</Link></Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>

            <Accordion expanded={`panel${tab + 1}` === 'panel2'}>
                <AccordionSummary style={{ display: 'none' }} />
                <AccordionDetails>
                    <form style={{ width: '100%' }} onSubmit={createAccount} autoComplete='on'>
                        <Grid container spacing={1} alignItems='stretch' direction='column'>
                            <Grid item>
                                <TextField
                                    autoComplete='username email'
                                    autoFocus
                                    required
                                    id='email_create'
                                    name='email'
                                    label='Email Address'
                                    variant='outlined'
                                    value={newUser.email.value}
                                    onChange={({ target: { value } }) =>
                                        setNewUser({ ...newUser, email: { value } })
                                    }
                                    onBlur={() =>
                                        setNewUser({
                                            ...newUser,
                                            email: {
                                                ...newUser.email,
                                                error: invalidEmail(newUser.email.value)
                                            }
                                        })
                                    }
                                    helperText={newUser.email.error}
                                    error={!!newUser.email.error}
                                    
                                />
                            </Grid>
                            <Grid item>
                                <PasswordField
                                    required
                                    autoComplete='new-password'
                                    id='password_create'
                                    name='new-password'
                                    label='Password'
                                    variant='outlined'
                                    value={newUser.password.value}
                                    onChange={({ target: { value } }) =>
                                        setNewUser({ ...newUser, password: { value } })
                                    }
                                    onBlur={() =>
                                        setNewUser({
                                            ...newUser,
                                            password: {
                                                ...newUser.password,
                                                error: invalidPassword(newUser.password.value)
                                            }
                                        })
                                    }
                                    helperText={newUser.password.error}
                                    error={!!newUser.password.error}
                                    
                                />
                            </Grid>
                            <Grid item>
                                <PasswordField
                                    required
                                    autoComplete='new-password'
                                    id='password_create_verify'
                                    name='confirm-new-password'
                                    label='Verify Password'
                                    variant='outlined'
                                    value={newUser.verify.value}
                                    onChange={({ target: { value } }) =>
                                        setNewUser({ ...newUser, verify: { value } })
                                    }
                                    onBlur={() =>
                                        setNewUser({
                                            ...newUser,
                                            verify: {
                                                ...newUser.verify,
                                                error:
                                                    newUser.verify.value &&
                                                    newUser.verify.value !== newUser.password.value
                                                        ? `Passwords don't match`
                                                        : ''
                                            }
                                        })
                                    }
                                    helperText={newUser.verify.error}
                                    error={!!newUser.verify.error}
                                    
                                />
                            </Grid>
                            <Grid item>
                                <Typography variant='body1'>User Details</Typography>
                            </Grid>
                            <Grid item>
                                <TextField
                                    required
                                    autoComplete='given-name'
                                    id='first'
                                    label='First Name'
                                    variant='outlined'
                                    value={newUser.first.value}
                                    onChange={({ target: { value } }) =>
                                        setNewUser({ ...newUser, first: { value } })
                                    }
                                    
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    required
                                    autoComplete='family-name'
                                    id='last'
                                    label='Last Name'
                                    variant='outlined'
                                    value={newUser.last.value}
                                    onChange={({ target: { value } }) =>
                                        setNewUser({ ...newUser, last: { value } })
                                    }
                                    
                                />
                            </Grid>
                            <Grid item>
                                <FormControl >
                                    <Button
                                        disabled={!readyForSubmit(newUser)}
                                        variant='contained'
                                        color='primary'
                                        type='submit'
                                        >
                                        Join
                                    </Button>
                                    <FormHelperText error id='component-error-text'>
                                        {submitError}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>
            {props.externalEntryCode || props.directURL ? (
                <Box px={3} py={2}>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant='body2' align='center' sx={{ mb: 1 }}>
                        Or enter as a guest (view only)
                    </Typography>
                    <form onSubmit={enterAsGuest}>
                        <Grid container spacing={1} alignItems='stretch' direction='column'>
                            <Grid item>
                                <TextField
                                    id='guest_name'
                                    label='Display Name (optional)'
                                    variant='outlined'
                                    size='small'
                                    fullWidth
                                    value={guestName}
                                    onChange={({ target: { value } }) => setGuestName(value)}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    fullWidth
                                    variant='outlined'
                                    color='primary'
                                    type='submit'
                                >
                                    Enter as Guest
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            ) : null}
            {loading ? <LoadingAnimation /> : null}
        </Dialog>
    );
}
